/* Athovita — lightweight interactivity (vanilla, no deps) */
(function () {
  'use strict';

  // ----- Tab switching -----
  // Wires any [data-ath-tabs] container so its [data-ath-tab] triggers
  // toggle the matching [data-ath-panel] elements.
  function initTabs(root) {
    root.querySelectorAll('[data-ath-tabs]').forEach((group) => {
      const buttons = group.querySelectorAll('[data-ath-tab]');
      buttons.forEach((btn) => {
        btn.addEventListener('click', () => {
          const target = btn.getAttribute('data-ath-tab');
          buttons.forEach((b) => {
            const isMatch = b.getAttribute('data-ath-tab') === target;
            b.classList.toggle('is-active', isMatch);
            b.setAttribute('aria-selected', isMatch ? 'true' : 'false');
          });
          group.parentElement.querySelectorAll('[data-ath-panel]').forEach((p) => {
            p.classList.toggle('is-active', p.getAttribute('data-ath-panel') === target);
          });
        });
      });
    });
  }

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(() => {
    initTabs(document);
  });

  // Export for re-init after AJAX
  window.AthovitaUI = { initTabs };
})();
